import { SvgLogo, SvgLogoProps } from './SvgLogo';

export const Telnyx = ({ height, width, ...props }: SvgLogoProps) => (
  <SvgLogo
    data-test="Telnyx"
    height={height}
    width={width}
    title="Telnyx Logo"
    titleId="telnyx-logo-title"
    viewBox="0 0 48 42"
    fill="none"
    {...props}
  >
    <g clipPath="url(#telnyx-logo-clip)">
      <path
        d="M39.5779 26.7928C39.5063 26.6831 39.41 26.5918 39.2965 26.5262C39.1831 26.4607 39.0559 26.4227 38.9251 26.4155H29.0745C28.9593 26.416 28.849 26.462 28.7676 26.5435C28.6861 26.6249 28.6402 26.7352 28.6396 26.8504V41.2322C28.6399 41.3475 28.6858 41.4581 28.7672 41.5397C28.8487 41.6214 28.9592 41.6675 29.0745 41.668H47.7312C47.9702 41.668 48.0691 41.4981 47.9491 41.2907L39.5779 26.7928Z"
        fill="#00C08B"
      />
      <path
        d="M18.9264 26.3789H9.07486C8.94407 26.3861 8.81682 26.424 8.70341 26.4896C8.58999 26.5551 8.49361 26.6465 8.42206 26.7562L0.0508592 41.2522C-0.0681808 41.4595 0.0297392 41.6295 0.268779 41.6295H18.9264C19.0419 41.6292 19.1526 41.5832 19.2343 41.5015C19.316 41.4198 19.362 41.3091 19.3622 41.1936V26.8147C19.362 26.6992 19.316 26.5885 19.2343 26.5068C19.1526 26.4252 19.0419 26.3792 18.9264 26.3789Z"
        fill="#00C08B"
      />
      <path
        d="M13.7097 18.3254H34.2537C34.4928 18.3254 34.5907 18.1555 34.4707 17.9482L24.1997 0.15552C24.0797 -0.05184 23.8838 -0.05184 23.7638 0.15552L13.4918 17.952C13.3718 18.1555 13.4697 18.3254 13.7097 18.3254Z"
        fill="#00C08B"
      />
    </g>
    <defs>
      <clipPath id="telnyx-logo-clip">
        <rect width="48" height="41.6678" fill="white" />
      </clipPath>
    </defs>
  </SvgLogo>
);
